import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../@bizkeytech";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";

/**@inheritDoc*/
export class ReportingToolsController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the list of task status groups from the server.
     * @param reportName        the name of the section to fetch the columns for.
     * @param abortController   the abort controller to cancel the request.
     */
    public async fetchDynamicColumns(reportName: string, abortController?: AbortController): models.FetchDynamicColumnsResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.reportingTools.getColumns,
            params: {
                reportName: reportName,
            },
            signal: abortController?.signal,
        });
    }
}


export * from "./index.types";
export default ReportingToolsController;
